import { useRouteLoaderData } from "react-router-dom";

import Loading from "@/components/layout/loading";
import Resolver from "@/components/resolver";
import ResolvedView from "./resolved-view";

export default function LocationsView() {
  const { project } = useRouteLoaderData("project");

  return (
    <div className="mt-10">
      <Resolver resolve={project} fallback={<Loading />}>
        <ResolvedView />
      </Resolver>
    </div>
  );
}
